import React from 'react';

import { importFromS3 } from '../../utils/importFromS3';

const CropPlanningPlugin = React.lazy(() => importFromS3('crop-planning'));


export const CropPlanningPluginContainer: React.FC = () => (
  <CropPlanningPlugin />
);
